import {
  type Middleware,
  combineReducers,
  configureStore
} from '@reduxjs/toolkit';
import type { TypedUseSelectorHook } from 'react-redux';
import { useDispatch, useSelector } from 'react-redux';

import { adminStore } from '@/AdminPanel/store';

import appSlice from './app.slice';
import authSlice from './auth.slice';
import clientInfoSlice from './client-info.slice';
import contractInfoSlice from './contract-info.slice';
import dictSlice from './dict.slice';
import leasedPropertyInfoSlice from './leased-property-info.slice';
import leasingScoringRequestsSlice from './leasing-scoring-requests.slice';
import userInfoSlice from './user-info.slice';

const rootReducer = combineReducers({
  ...adminStore,
  app: appSlice.reducer,
  dict: dictSlice.reducer,
  auth: authSlice.reducer,
  userInfo: userInfoSlice.reducer,
  leasingScoringRequests: leasingScoringRequestsSlice.reducer,
  leasedPropertyInfo: leasedPropertyInfoSlice.reducer,
  contractInfo: contractInfoSlice.reducer,
  clientInfo: clientInfoSlice.reducer
});

const middleware: Middleware[] = [];

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(middleware)
});

export const dispatch = store.dispatch.bind(store);
export type TRootState = ReturnType<typeof store.getState>;
type TAppDispatch = typeof store.dispatch;

export const useAppDispatch: () => TAppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<TRootState> = useSelector;
